module.exports = __webpack_public_path__ + "img/pie-chart-blue.9d3c863c.svg";